// extracted by mini-css-extract-plugin
module.exports = {"container":"B_b","scroller":"B_bB","room":"B_bC","roomCurrent":"B_bD","hidden":"B_0","load":"B_V","windowLight":"B_k"};